import React from 'react';
import ChevronDownRightIcon from '$assets/svgs/chevron-down-right.svg?react';
import {getRoute, RouteSection} from '$utils/route';
import {useNavigate} from 'react-router-dom';
import './styles.scss';

interface PatientBreadcrumbProps {
  patientName: string;
}

const PatientBreadcrumb: React.FC<PatientBreadcrumbProps> = ({patientName}) => {
  const navigate = useNavigate();
  return (
    <span className="patient-details__header__patient-name">
      <span
        className="patient-details__header__breadcrumb patient-details__header__breadcrumb--clickable"
        onClick={() => navigate(getRoute(RouteSection.PatientList))}
      >
        Patient list
      </span>
      <span className="patient-details__header__breadcrumb-separator">
        <ChevronDownRightIcon style={{color: '#475467'}} />
      </span>
      <span className="patient-details__header__patient-actual-name">
        {patientName}
      </span>
    </span>
  );
};

export default PatientBreadcrumb;
